import { render, staticRenderFns } from "./showContents.vue?vue&type=template&id=8c42d9c6&scoped=true"
import script from "./showContents.vue?vue&type=script&lang=js"
export * from "./showContents.vue?vue&type=script&lang=js"
import style0 from "./showContents.vue?vue&type=style&index=0&id=8c42d9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c42d9c6",
  null
  
)

export default component.exports